import React from 'react' 
import _ from 'lodash'

const FetchLocations = props => {
const result = props.payload
console.log(props)
const aiports = _.filter(result, { CATEGORY: 'Airports' })
const cities = _.filter(result, { CATEGORY: 'Ciudad' })
const hotels = _.filter(result, { CATEGORY: 'Hoteles' })
return (
<div className="select-style locations">
<select
name={props.inputName}
onChange={props.onChange}
value={props.pickupLocation}
>
<option>{props.label}</option>
{aiports.length > 0 ? (
<optgroup label={props.lang === 'es' ? 'Aeropuertos' : 'Airports'}>
{_.map(aiports, ({ ID, OFFICE }) => {
return (
<option value={ID} key={ID}>
{OFFICE}
</option>
)
})}
</optgroup>
) : null}
{cities.length > 0 ? (
<optgroup label={props.lang === 'es' ? 'Ciudad' : 'Cities'}>
{_.map(cities, ({ ID, OFFICE }) => {
return (
<option value={ID} key={ID}>
{OFFICE}
</option>
)
})}
</optgroup>
) : null}
{hotels.length > 0 ? (
<optgroup label={props.lang === 'es' ? 'Hoteles' : 'Hotels'}>
{_.map(hotels, ({ ID, OFFICE }) => {
return (
<option value={ID} key={ID}>
{OFFICE}
</option>
)
})}
</optgroup>
) : null}
</select>
</div>
)
}

export default FetchLocations


// WEBPACK FOOTER //
// ./src/components/MainForm/Locations.js